"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12.211 7.288c.79 0 1.78-.534 2.37-1.246.534-.645.923-1.546.923-2.448a1.7 1.7 0 0 0-.033-.345c-.879.033-1.936.59-2.57 1.335-.501.567-.957 1.457-.957 2.37 0 .134.022.267.033.311a1.3 1.3 0 0 0 .234.022zM9.43 20.75c1.079 0 1.558-.723 2.904-.723 1.368 0 1.669.701 2.87.701 1.179 0 1.969-1.09 2.715-2.158.834-1.224 1.179-2.425 1.202-2.481-.078-.022-2.336-.946-2.336-3.538 0-2.247 1.78-3.26 1.88-3.338-1.179-1.691-2.97-1.736-3.46-1.736-1.324 0-2.403.801-3.082.801-.734 0-1.702-.757-2.848-.757-2.181 0-4.394 1.802-4.394 5.207 0 2.114.823 4.35 1.836 5.796.868 1.224 1.624 2.225 2.715 2.225z"
}), 'Apple');
